module.exports = __webpack_public_path__ + "img/google_badge.fcffd9e7.svg";